var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$store.state.sound!==null)?_c('AudioPlayer',{key:_vm.$store.state.songid+Math.random(),attrs:{"preload":true}}):_vm._e(),_c('router-view',{key:_vm.$route.fullPath})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }